import React, { Component } from 'react';
import { Row, Col, Button } from 'antd';
import { Document, Page } from 'react-pdf'
import sample from '../../documento.pdf';
import OrderAddContainer from '../containers/OrderAddContainer';

class HomeView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1
        };
    }

    render() {
        const pageNumber = this.state.pageNumber;
        const numPages = 54;
        return(
            <div>
                <Row>
                    <Col span={18}>
                        <div>
                            <Button shape="circle" icon="caret-left" onClick={() => { (pageNumber > 1)?this.setState({ pageNumber: pageNumber - 1}):null; }} />
                            <span></span>
                            <Button shape="circle" icon="caret-right" onClick={() => { (pageNumber < numPages)?this.setState({ pageNumber: pageNumber + 1}):null; }} />
                            <Document
                            file={sample}
                            onLoadSuccess={this.onDocumentLoadSuccess}
                            >
                            <Page pageNumber={pageNumber} />
                            </Document>
                            <p>Page {pageNumber} of {numPages}</p>
                        </div>
                    </Col>
                    <Col span={6}>
                        <OrderAddContainer user={this.props.user} />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default HomeView;



// WEBPACK FOOTER //
// ./src/components/views/HomeView.jsx